import(/* webpackMode: "eager" */ "/vercel/path0/app/contact/page.tsx");
